import { DownloadStatus } from '../../../interfaces/billing.rpm';
import { ExportedClaimStatus } from '../../../interfaces/billing';
import { StyledTheme } from '../../../styles/styleTheme';
import { RpmStatus } from '../types/rpms.types';
import { CodeChipLevel } from './CodeChipList';

export const getStatusChipColor = (status: string) => {
  switch (status) {
    case RpmStatus.VALID:
      return { backgroundColor: StyledTheme.greenMint, color: '#fff' };
    case RpmStatus.INVALID:
      return { backgroundColor: StyledTheme.redLightMui, color: '#fff' };
    default:
      return { backgroundColor: StyledTheme.grayLight, color: '#000' };
  }
};

export const getExportedNoteStatusChipColor = (status: DownloadStatus) => {
  const chipColorByStatus = {
    [DownloadStatus.COMPLETED]: { backgroundColor: StyledTheme.greenMint, color: '#fff' },
    [DownloadStatus.FAILED]: { backgroundColor: StyledTheme.redLightMui, color: '#fff' },
    [DownloadStatus.PENDING]: { backgroundColor: '#fff3e0', color: '#ed6c02' },
  };

  return chipColorByStatus[status] ? chipColorByStatus[status] : {};
};

export const getDetailChipColor = (level: CodeChipLevel) => {
  const styleDefinition: { [key in CodeChipLevel]: { backgroundColor: string; color: string } } = {
    error: { backgroundColor: '#F8D7DA', color: '#721C24' },
    info: { backgroundColor: '#E2E3E5', color: '#383D41' },
    warning: { backgroundColor: '#FFF3CD', color: '#856404' },
  };

  return styleDefinition[level] ?? styleDefinition['info'];
};

export const getExportedClaimStatusChipColor = (status: ExportedClaimStatus | string) => {
  switch (status) {
    case ExportedClaimStatus.EXPORTED:
      return { backgroundColor: '#4caf50', color: '#fff' }; // Green
    case ExportedClaimStatus.EXPORTED_WITH_WARNINGS:
      return { backgroundColor: '#ff9800', color: '#fff' }; // Yellow/Orange
    case ExportedClaimStatus.NOT_EXPORTED:
      return { backgroundColor: '#f44336', color: '#fff' }; // Red
    default:
      return { backgroundColor: StyledTheme.grayLight, color: '#000' };
  }
};

// Unified RPM claim status colors (handles both created and exported statuses)
export const getRPMClaimStatusChipColor = (status: string) => {
  switch (status) {
    // Created statuses
    case 'CREATED':
      return { backgroundColor: StyledTheme.blueMunsell, color: '#fff' }; // Teal blue - Ready to export
    case 'CREATED_WITH_WARNINGS':
      return { backgroundColor: StyledTheme.turquoise, color: StyledTheme.masala }; // Light turquoise - Warnings
    case 'CREATED_WITH_ERRORS':
      return { backgroundColor: StyledTheme.salmon, color: '#fff' }; // Salmon - Blocked/needs attention

    // Exported statuses
    case 'EXPORTED':
      return { backgroundColor: StyledTheme.greenMint, color: '#fff' }; // Mint green - Success
    case 'EXPORTED_WITH_WARNINGS':
      return { backgroundColor: StyledTheme.yellowLightMui, color: StyledTheme.masala }; // Orange - Warnings
    case 'NOT_EXPORTED':
      return { backgroundColor: StyledTheme.redLightMui, color: '#fff' }; // Red - Failed

    default:
      return { backgroundColor: StyledTheme.grayLight, color: '#000' };
  }
};

export const getLogChipColor = (status: string) => {
  switch (status.toUpperCase()) {
    case 'ERROR':
      return { backgroundColor: '#fdecea', color: '#d32f2f' };
    case 'WARNING':
      return { backgroundColor: '#fff3e0', color: '#ed6c02' };
    case 'INFO':
      return { backgroundColor: '#e3f2fd', color: '#1976d2' };
    case 'DEBUG':
      return { backgroundColor: '#f5f5f5', color: '#757575' };
    default:
      return { backgroundColor: '#f5f5f5', color: '#757575' };
  }
};
